import { render, staticRenderFns } from "./LocationManageList.vue?vue&type=template&id=1d39136c"
import script from "./LocationManageList.vue?vue&type=script&lang=js"
export * from "./LocationManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports